import { doctorConstants } from '../_constants/doctor.constants';

export const initialState = {
  errors: [],
  isSaving: false,
  collection: []
}

export function doctor(state = initialState, action) {
  if (action.type === doctorConstants.GETALL_DOCTORS_SUCCESS) {
    return {
      ...state,
      collection: action.collection
    }
  }

  return state;
}
